import { Injectable } from '@angular/core';
@Injectable()
export class NumberConstants {
    ZERO: number = 0;
    ONE: number = 1;
    TWO: number = 2;
    FOUR: number = 4;
    SIX: number = 6;
    TEN: number = 10;
    TWELVE: number = 12;
    ALERT_DELAY_3000: number = 3000;
    ALERT_DELAY_1000: number = 1000;
    FORTYFIVE: number = 45;
    MINUS_ONE = -1;
    ALERT_DELAY_5000 = 5000;
    ALERT_DELAY_8000 = 8000;
    ALERT_DELAY_10000 = 10000;
    TEXTLENGTH_500 = 500;
    TEXTLENGTH_255 = 255;
    SELECTEDOBJECT: number = 0;
    SELECTEDVERSION: number = 1;
    SELECTEDCATEGORY: number = 1;
    CLONE: number = 2;

    //load based on configset
    ALLPRODUCTS: number = 1;
    HASNOCONFIGSET: number = 2;
    HASCONFIGSET: number = 3;
    HASCONFIGSETANDPUBLISHED: number = 4;

    SELECTEDPRODUCT: number = 3;
    SOURCECATEGORY: number = 3;
    CLONEVERSION: number = 4;
    CONFIGSET: number = 5;
    MAXIMUMCATEGORY: number = 5;
    SELECTDMAXIMUMCATEGORY: number = 6;
    CATEGORYSORTDATA: number = 7;
    SUBMAXIMUM: number = 9;
    SUBCATEGORYSORTDATA: number = 10;
    PRODMANAGER: number = 12;
    PRIMARYAUTHOR: number = 13;
    DESCRIPTION: number = 13;
    COMMENTS: number = 6;
    APPROVEDSTATUS: number = 3;
    KEYOBJECT: number = 2;
    //AuthorTypes
    PERFORMANCEAUTHOR: number = 4;
    QEAUTHOR: number = 5;
    PRODAUTHOR: number = 6;
    DEVAUTHOR: number = 7;
    //Maximum attributes
    TARGET: number = 8;
    ATTRIBUTE: number = 9;
    TEST: number = 10;
    PMT: number = 11;
    INTERNAL: number = 12;
    PUBLISHDATE: number = 5;
    STATUS: number = 7;
    SELECTEDCONFIGSET: number = 8;
    PUBLISHVAL: number = 9;

    HEAD: number = 0;
    LABEL: number = 1;
    LIMIT: number = 3;
    APPROVEDSTATUSSTRING: String = "3";
    ISINTRNAL: String = "false";
    NOTAPPLICALBLE: String ="NA";
    SEPERATOR:String  ="-/-";

}


// WEBPACK FOOTER //
// ./src/app/common/numberconstants.ts